import React from 'react'
import { observer } from 'mobx-react-lite'

import { type SxProps } from '@mui/material/styles'

import {
  ConnectDrawer,
  Loader,
  MiniWidgetContainer,
  useGlobalCopyStore,
  useGlobalUiStore,
  useWidgetLoadTimer,
} from '../common'

import ConnectMiniWidgetCard from './components/ConnectMiniWidgetCard'

interface ConnectMiniWidgetProps {
  onPrimaryCtaClick?: () => void
  sx?: SxProps
}

const ConnectMiniWidget: React.FC<ConnectMiniWidgetProps> = ({
  onPrimaryCtaClick = () => {},
  sx,
}) => {
  const { isCopyLoaded } = useGlobalUiStore()
  const { connect: connectCopy } = useGlobalCopyStore()

  const [showConnectWidget, setShowConnectWidget] = React.useState(false)

  const onCtaClick = () => {
    setShowConnectWidget(true)
    onPrimaryCtaClick()
  }

  useWidgetLoadTimer({
    widgetName: 'ConnectMiniWidget',
    isLoaded: isCopyLoaded,
  })

  if (!isCopyLoaded) {
    return <Loader />
  }

  return (
    <MiniWidgetContainer
      className="mx-exp-connect-miniwidget"
      onPrimaryCtaClick={onCtaClick}
      primaryCtaLabel={connectCopy.primary_cta}
      sx={sx}
      title={connectCopy.mini_title}
    >
      <ConnectMiniWidgetCard />
      {showConnectWidget && (
        <ConnectDrawer
          onClose={() => setShowConnectWidget(false)}
          showConnectWidget={showConnectWidget}
          title={connectCopy.mini_title}
        />
      )}
    </MiniWidgetContainer>
  )
}

export default observer(ConnectMiniWidget)
